import { render } from "./AlimentationInput.vue?vue&type=template&id=4d9b500d"
import script from "./AlimentationInput.vue?vue&type=script&lang=js"
export * from "./AlimentationInput.vue?vue&type=script&lang=js"

import "./AlimentationInput.vue?vue&type=style&index=0&id=4d9b500d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__